import React from 'react';

const UpgradeNudgeZaps = () => (
  <svg fill="none" width="100%" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d)">
      <path
        d="M10 145C10 139.477 14.4772 135 20 135H480C485.523 135 490 139.477 490 145V235C490 240.523 485.523 245 480 245H20C14.4771 245 10 240.523 10 235V145Z"
        fill="white"
      />
    </g>
    <rect fill="#F2F2F2" height="25" rx="5" width="260" x="165" y="165" />
    <rect fill="#F2F2F2" height="15" rx="2" width="130" x="165" y="200" />
    <path
      d="M40 175C40 169.477 44.4772 165 50 165H90V215H50C44.4772 215 40 210.523 40 205V175Z"
      fill="#FFE1D5"
    />
    <path
      d="M145 205C145 210.523 140.523 215 135 215L95 215L95 165L135 165C140.523 165 145 169.477 145 175L145 205Z"
      fill="#2655BD"
    />
    <g filter="url(#filter1_d)">
      <path
        d="M10 15C10 9.47715 14.4772 5 20 5H480C485.523 5 490 9.47715 490 15V105C490 110.523 485.523 115 480 115H20C14.4771 115 10 110.523 10 105V15Z"
        fill="white"
      />
    </g>
    <rect fill="#F2F2F2" height="25" rx="5" width="260" x="165" y="35" />
    <rect fill="#F2F2F2" height="15" rx="2" width="130" x="165" y="70" />
    <path
      d="M40 45C40 39.4772 44.4772 35 50 35H90V85H50C44.4772 85 40 80.5228 40 75V45Z"
      fill="#62D493"
    />
    <path
      d="M145 75C145 80.5228 140.523 85 135 85L95 85L95 35L135 35C140.523 35 145 39.4772 145 45L145 75Z"
      fill="#DAF5E6"
    />
    <g filter="url(#filter2_d)">
      <path
        d="M10 275C10 269.477 14.4772 265 20 265H480C485.523 265 490 269.477 490 275V365C490 370.523 485.523 375 480 375H20C14.4771 375 10 370.523 10 365V275Z"
        fill="white"
      />
    </g>
    <rect fill="#F2F2F2" height="25" rx="5" width="260" x="165" y="295" />
    <rect fill="#F2F2F2" height="15" rx="2" width="130" x="165" y="330" />
    <path
      d="M40 305C40 299.477 44.4772 295 50 295H90V345H50C44.4772 345 40 340.523 40 335V305Z"
      fill="#FFC43E"
    />
    <path
      d="M145 335C145 340.523 140.523 345 135 345L95 345L95 295L135 295C140.523 295 145 299.477 145 305L145 335Z"
      fill="#999999"
    />
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="130"
        id="filter0_d"
        width="500"
        x="0"
        y="130"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow"
          mode="normal"
          result="shape"
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="130"
        id="filter1_d"
        width="500"
        x="0"
        y="0"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow"
          mode="normal"
          result="shape"
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="130"
        id="filter2_d"
        width="500"
        x="0"
        y="260"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow"
          mode="normal"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default UpgradeNudgeZaps;
